//
import fetchAll from './fetchAll'
import fetchByFamily from './fetchByFamily'

//
export default {
    fetchAll,
    fetchByFamily,
}
